const ITEMS = [
    "Ports & terminals",
    "Maritime & shipping",
    "Logistics",
    "Cold chain",
    "Pharma supply chains",
    "Energy transition",
    "Infrastructure, globally",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span
                key={item}
                className="flex items-center whitespace-nowrap font-serif text-2xl italic text-ink sm:text-3xl"
            >
                {item}
                <span
                    className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-gold"
                    aria-hidden="true"
                />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section
        aria-hidden="true"
        data-testid="marquee"
        className="overflow-hidden border-y border-ink/10 bg-paper py-6"
    >
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </section>
);

export default Marquee;
